import { render, staticRenderFns } from "./PublicNav.vue?vue&type=template&id=506b2cd3&"
import script from "./PublicNav.vue?vue&type=script&lang=js&"
export * from "./PublicNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports